// extracted by mini-css-extract-plugin
export default {"Kahoot":"Kahoot_Kahoot__SxL8F","shad":"Kahoot_shad__Jl6bT","input":"Kahoot_input__iNVdt","myButton":"Kahoot_myButton__MAZ6M"};